/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Newsletter_ErrorInputs */

const ja_playdata_home_newsletter_error = /** @type {(inputs: Playdata_Home_Newsletter_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信できませんでした。時間をおいて再度お試しいただくか、お問い合わせよりご連絡ください。`)
};

const en_playdata_home_newsletter_error = /** @type {(inputs: Playdata_Home_Newsletter_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, that did not go through. Please try again, or contact us directly.`)
};

/**
* | output |
* | --- |
* | "Sorry, that did not go through. Please try again, or contact us directly." |
*
* @param {Playdata_Home_Newsletter_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_newsletter_error = /** @type {((inputs?: Playdata_Home_Newsletter_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Newsletter_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_newsletter_error(inputs)
	return en_playdata_home_newsletter_error(inputs)
});